import { useDispatch } from 'react-redux';
import CrudActionContainer from './CrudActionContainer';
import ChatbotCRUDActions from './ChatbotCRUDActions';
import ValidationMessagesContoller from '../controllers/ValidationMessagesController';
import commonHandler from '../errorHandlers/common-handler';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { ValidationMessageModel } from '../model/ValidationMessageModel';

export type CreateValidationMessageParams = {
  ruleName: string;
  body: string;
  botId: number;
};

class ValidationMessageCRUDActions extends CrudActionContainer {
  constructor() {
    super('VALIDATION_MESSAGE');
  }

  create(entity: CreateValidationMessageParams) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));
        const response =
          await ValidationMessagesContoller.postValidationMessage(entity);
        dispatch(this.unbusy());
        dispatch(ChatbotCRUDActions.retrieve(entity.botId));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(entity) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await ValidationMessagesContoller.putValidationMessage(
          entity,
        );
        dispatch(this.updateLocal(entity));
        dispatch(ChatbotCRUDActions.retrieve(entity.botId));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

const validationMessageCRUDActions = new ValidationMessageCRUDActions();

export default validationMessageCRUDActions;

export const useValidationMessageCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return {
    create: (entity: CreateValidationMessageParams) =>
      dispatch(validationMessageCRUDActions.create(entity)),
    update: (entity: ValidationMessageModel) =>
      dispatch(validationMessageCRUDActions.update(entity)),
  };
};
